/*
 * @Author: 孙福聪
 * @Date: 2019-01-16 16:01:56
 * @Last Modified by: 孙福聪
 * @Last Modified time: 2019-03-12 10:34:56
 * @Last Modified by: 孙福聪
 * @Last Modified time: 2019-03-12 15:18:20
 * @Last Modified by: 孙福聪
 * @Last Modified time: 2019-03-27 11:58:23
 */
import NodeRSA from "jsencrypt";
import https from "./fetch";
const http = https.http;
const key = new NodeRSA();
key.setPublicKey(
  "-----BEGIN RSA PRIVATE KEY-----\n" +
    `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCfmqOtshQkeQ0UkmNqcEvbX9v5ln7CzMOIGsCm
  WSLYVoCo9hVYCGUXbbQX8i0L7gtnNF+LtNgyVHTrmzEjS8EnhHjV8swF3XMK8mk1Z3TszzmHMJbn
  s/F1oItSuO6oF0R3TYy4NGWbjLFnH/U7DycOgZr2dLuiEVrf2PB4Dlnj8wIDAQAB` +
    "-----END RSA PRIVATE KEY-----"
);
export default {
  ping() {
    return http.post("./ping/ping");
  },
  // 登录
  login(state) {
    const password = state.password.trim();
    state.password = key.encrypt(password, "base-64");
    return http.post("./api/user/login", state);
  },
  // 获取默认密码
  getDefaultPassword() {
    return http.post("./api/defaultInfo/getDefaultPassword");
  },

  // 获取用户信息
  userInfo(code) {
    return http.post("./api/user/getByCode", code);
  },
  // 软件配置
  softConfig() {
    return http.get("./softConfig/get");
  },
  getVersion() {
    // 软件版本
    return http.get("./version/get");
  },
  getTeacherlist(data) {
    // 查询教师列表（弃用）
    return http.post("./api/user/listTeachers", data);
  },
  createUser(data) {
    // 创建用户
    return http.post("./api/user/addUser", data);
  },
  editorUser(data) {
    // 修改用户
    return http.post("./api/user/changeUserInfo", data);
  },
  listUser(data) {
    // 查询老师列表或查询教师列表
    return http.post("./classMember/queryTeacherMember", data);
  },
  getUserList(data) {
    // 查询用户列表
    return http.post("./api/user/listUsers", data);
  },
  deleteUser(data) {
    // 删除教师用户
    return http.post("./classMember/deletingClassMember", data);
  },
  getCaseExperimentById(data) {
    // 根据id查询案例内容
    return http.post("./api/caseExperiment/getCaseExperimentById", data);
  },
  createClass(data) {
    // 创建班级
    return http.post("./class/createOrUpdateClass", data);
  },
  deleteClass(data) {
    // 删除班级
    return http.post("./class/batchDeletingClass", data);
  },
  createclassStudent(data) {
    // 创建各班级的学生
    return http.post("./classMember/createOrUpdateClassMember", data);
  },
  deleteStudent(data) {
    // 删除各班学生
    return http.post("./classMember/deletingClassMember", data);
  },
  editorStudent(data) {
    // 编辑学生
    return http.post("./api/user/changeUserInfo", data);
  },
  resetPassword(data) {
    const newPassword = data.newPassword.trim();
    data.newPassword = key.encrypt(newPassword, "base-64");
    // 重置密码
    return http.post("./api/user/resetPassword", data);
  },
  /**
   * AI案例生成
   */
  generateCase(data) {
    return http.post("./api/caseExperiment/aiCase", data);
  },
  /**
   * 是否开启AIGC
   */
  getEnableState() {
    return http.get("./api/caseExperiment/getEnableState");
  },
  createCaseExperiment(data) {
    // 新建自定义案例
    return http.post("./api/caseExperiment/createCaseExperiment", data);
  },
  updateCaseExperiment(data) {
    // 编辑自定义案例
    return http.post("./api/caseExperiment/updateCaseExperiment", data, {
      timeout: null
    });
  },
  /** 根据id获得案例介绍 2021年3月3日 */
  getCaseIntroduce(data) {
    return http.post("./api/caseExperiment/getCaseIntroduce", data);
  },
  /** 添加我的办公室任务完成状态 */
  mergerTaskScenarioRelation(data) {
    return http.post("./api/TaskScenario/mergerTaskScenarioRelation", data);
  },
  createOrUpdateCaseDepartmentStep(data) {
    // 添加部门基础大厅
    if (!data.list.length) return { data: { success: true } };
    return http.post("./api/caseDepartmentStep/createOrUpdateCaseDepartmentStep", data);
  },
  getCasehallByPyIdAndCaseStep(data) {
    // 查询部门基础大厅
    return http.post("./api/caseHall/getCasehallByPyIdAndCaseStep", data);
  },
  createOrUpdateCaseHall(data) {
    // 设置基础信息步骤
    return http.post("./api/caseHall/createOrUpdateCaseHall", data);
  },
  batchDeletingCaseDepartmentStep(data) {
    // 删除基础部门信息
    return http.post("./api/caseDepartmentStep/batchDeletingCaseDepartmentStep", data);
  },
  listCaseDepartmentStepByChid(data) {
    // 查询基础部门信息
    return http.post("./api/caseDepartmentStep/listCaseDepartmentStepByChid", data);
  },
  getCaseDepartmentStepById(data) {
    // 根据id查询部门
    return http.post("./api/caseDepartmentStep/getCaseDepartmentStepById", data);
  },
  AddOrUpdateTask(data) {
    // 新建任务列表
    return http.post("./api/Task/AddOrUpdateTask", data);
  },
  getTaskById(data) {
    // 查询单个任务列表
    return http.post("./api/Task/getTaskById", data);
  },
  listTaskByChid(data) {
    // 查询任务列表
    return http.post("./api/Task/listTaskByChid", data);
  },
  removeTask(data) {
    // 删除任务列表某一项
    return http.post("./api/Task/removeTask", data);
  },
  AddOrUpdateTaskScenario(data) {
    // 创建任务下场景
    return http.post("./api/TaskScenario/AddOrUpdateTaskScenario", data);
  },
  deleteTeacherTransfetClass(data) {
    // 转移班级接口
    return http.post("./classMember/deleteTeacherTransfetClass", data);
  },
  deletingClassMember(data) {
    // 彻底删除用户
    return http.post("./classMember/deletingClassMember", data);
  },

  batchUpdateTasks(data) {
    // 批量修改任务
    return http.post("./api/Task/batchUpdateTasks", data);
  },
  listTaskScenarioByTaid(data) {
    // 查询任务下场景
    return http.post("./api/TaskScenario/listTaskScenarioByTaid", data);
  },
  listMyOffice(data) {
    // 查询阶段下所有我的办公室
    return http.post("./api/TaskScenario/listMyOffice", data);
  },
  getTaskScenarioByIds(data) {
    // 多个查询任务下场景
    return http.post("./api/TaskScenario/getTaskScenarioByIds", data, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      }
    });
  },
  batchDeletingTaskScenario(data) {
    // 删除任务下场景
    return http.post("./api/TaskScenario/batchDeletingTaskScenario", data);
  },
  batchDeletingCaseExperiment(data) {
    // 删除自定义案例
    return http.post("./api/caseExperiment/batchDeletingCaseExperiment", data);
  },
  createOrUpdateControl(data) {
    // 添加控件
    return http.post("./api/Control/createOrUpdateControl", data, {
      timeout: null
    });
  },
  listControlByTsid(data) {
    // 查询控件
    return http.post("./api/Control/listControlByTsid", data);
  },
  batchDeletingControl(data) {
    // 删除控件
    return http.post("./api/Control/batchDeletingControl", data);
  },
  listCaseExperimentRequest(data) {
    // 查询自定义案例
    return http.post("./api/caseExperiment/listCaseExperimentRequest", data);
  },
  listAuditStatusPassExperiment(data) {
    // 查询自定义案例
    return http.post("./api/caseExperiment/listAuditStatusPassExperiment", data);
  },
  // 实验管理模块
  listClassRequest(data) {
    return http.post("./class/listClassRequest", data);
  },
  listClassMemberRequest(data) {
    // 查询班级下学生
    return http.post("./classMember/listClassMemberRequest", data);
  },
  createOrUpdateExperiment(data) {
    // 教师分配的案例
    return http.post("./api/experiment/createOrUpdateExperiment", data);
  },
  queryExperiment(data) {
    // 教师分配案例日志
    return http.post("./api/experiment/queryExperiment", data);
  },
  removeExperiment(data) {
    // 教师删除分配案例日志
    return http.post("./api/experiment/removeExperiment", data);
  },
  updateExperiment(data) {
    // 延续分配修改
    return http.post("./api/experiment/updateExperiment", data);
  },
  showExperimentMeber(data) {
    // 报告管理 二级页面 查看实训下所有学生的实训
    return http.post("./api/experimentMember/showExperimentMeber", data);
  },
  deleteExperimentMeber(data) {
    // 报告管理 二级页面 删除和批量删除
    return http.post("./api/experimentMember/deleteExperimentMeber", data);
  },
  finishExperiment(data) {
    // 报告管理 教师结束实训
    return http.post("./api/experiment/finishExperiment", data);
  },
  pushGradeToStu(data) {
    // 报告管理 教师智能评分
    return http.post("./api/experimentMember/pushGradeToStu", data);
  },
  pushGradeIntellect(data) {
    // 报告管理 教师智能评分
    return http.post("./api/experimentMember/pushGradeIntellect", data);
  },
  exportScore(data) {
    // 报告管理 一级页面 下载详情
    return http.post("./api/exportExcel/exportScore", data);
  },
  exportExperimentReport(data) {
    // 二级页面 下载pdf报告
    return http.post("./api/exportExperimentReport/exportExperimentReport", data);
  },
  exportReportToZIp(data) {
    // 二级页面 批量导出报告 zip包
    return http.post("./api/exportExperimentReport/exportReportToZIp", data);
  },
  queryStuScoreRequest(data) {
    // 报告页面查询系统评分
    return http.post("./api/queryStuScore/queryStuScoreRequest", data);
  },
  teacherToGradeStu(data) {
    // 报告管理老师打分
    return http.post("./api/experimentMember/teacherToGradeStu", data);
  },
  listStuControl(data) {
    // 查看学生做题目集合
    return http.post("./api/stuControl/listStuControl", data);
  },
  showStuData(data) {
    // 在线预览报告数据
    return http.post("./api/exportExperimentReport/showStuData", data);
  },
  getByCode(data) {
    // 查询个人资料
    return http.post("./api/user/getByCode", data);
  },
  changePassword(data) {
    // 修改密码
    const oldPassword = data.oldPassword.trim();
    data.oldPassword = key.encrypt(oldPassword, "base-64");
    const newPassword = data.newPassword.trim();
    data.newPassword = key.encrypt(newPassword, "base-64");
    return http.post("./api/user/changePassword", data);
  },
  changeUserSignature(data) {
    // 修改用户信息
    return http.post("./api/user/changeUserSignature", data);
  },
  learndata(data) {
    // 查询学习资料
    return http.post("./api/getMaterials", data);
  },
  uploaddata(data) {
    return http.post("./api/updateFile", data, {
      timeout: null
    });
  },
  deletelearn(data) {
    return http.post("./api/removeFile", data);
  },
  downLoadZipFile(data) {
    // 打包下载
    return http.post("./api/downLoadZipFile", data);
  },
  editorlearn(data) {
    // 修改学习资料
    return http.post("./api/updateMaterial", data);
  },
  createOrEditorNoun(data) {
    // 创建名词或修改名词
    return http.post("./api/createProfessionalTerm", data);
  },
  NounList(data) {
    // 查询专业名词
    return http.post("./api/getTerms", data);
  },
  deleteNoun(data) {
    // 删除专业名词
    return http.post("./api/removeTerms", data);
  },
  createOrEditorLink(data) {
    // 创建链接或修改链接
    return http.post("./api/createWebLink", data);
  },
  LinkList(data) {
    // 查询网络链接
    return http.post("./api/getLinks", data);
  },
  createInternalNotification(data) {
    // 创建内部通知
    return http.post("./notification/createInternalNotification", data);
  },
  listInternalNotification(data) {
    // 查询内部通知
    return http.post("./notification/listInternalNotification", data);
  },
  batchDeletingNotification(data) {
    // 删除通知
    return http.post("./notification/batchDeletingNotification", data);
  },
  deleteAllNotification() {
    // 删除个人全部通知
    return http.post("./notification/deleteAllNotification");
  },
  deleteLink(data) {
    // 删除网络链接
    return http.post("./api/removeWebLinks", data);
  },
  querystudentclass(data) {
    // 查询学生所在班级
    return http.post("./api/class/getClassRoomByUserCode", data);
  },
  querydistributiontrain(data) {
    // 学生查询被分配的实训
    return http.post("./api/experimentMember/queryExperimentMemberOrderByEndTime", data);
  },
  ObtainExperimenttotal(data) {
    // 获取学生完成的实验总数
    return http.post("./api/experimentMember/getTotalExperiment", data);
  },
  Seedetails(data) {
    // 流程演练 查看详情
    return http.post("./api/experimentMember/showProcessDrillsExperiment", data);
  },
  querytrainProgress(data) {
    // 查询实训进度
    return http.post("./api/experimentMember/queryExperimentSchedule", data);
  },
  querypersonalnotice(data) {
    // 查询个人的全部通知
    return http.post("./notification/listAll", data);
  },
  selectStuIsFirstEntry(data) {
    // 查询学生是不是第一次进入某个实训
    return http.post("./api/experimentMember/selectStuIsFirstEntry", data);
  },
  queryUnreadnotice(data) {
    // 查询未读通知个数
    return http.post("./notification/unReadCount", data);
  },
  createOrUpdateExperimentMember(data) {
    // 创建修改学生实训
    return http.post("./api/experimentMember/createOrUpdateExperimentMember", data);
  },
  queryTaskByStu(data) {
    // 查询已做的任务
    return http.post("./api/Task/queryTaskByStu", data);
  },
  createStuControl(data) {
    // 学生做题接口
    return http.post("./api/stuControl/createStuControl", data);
  },
  NeedApprovalcustomCaselist(data) {
    // 查询需要审批学生的自定义案例
    return http.post("./api/caseExperiment/getAuditCaseExperimentRequest", data);
  },
  stuListCaseExperiment(data) {
    // 学生查询自定义案例
    return http.post("./api/caseExperiment/stuListCaseExperiment", data);
  },
  queryInvestigateMyDocument(data) {
    // 根据阶段查询学生做题
    return http.post("./api/stuControl/queryInvestigateMyDocument", data);
  },
  getStuControlById(data) {
    // 根据阶段查询学生做题
    return http.post("./api/stuControl/getStuControlById", data);
  },
  listWithoutNotification(data) {
    // 查询外部通知
    return http.post("./notification/listWithoutNotification", data);
  },
  shareMaterialToUsers(data) {
    // 分享学习资料
    return http.post("./api/shareMaterialToUsers", data);
  },
  shareProfessionalTermToUser(data) {
    // 分享专业名词
    return http.post("./api/shareProfessionalTermToUser", data);
  },
  shareWebLinkToUser(data) {
    // 分享网络链接
    return http.post("./api/shareWebLinkToUser", data);
  },
  copyCaseExperiment(data) {
    // 复制自定义案例
    return http.post("./api/caseExperiment/copyCaseExperiment", data);
  },
  shareCaseExperiment(data) {
    // 分享自定义案例
    return http.post("./api/caseExperiment/shareCaseExperiment", data);
  },
  updateNotificationRead(data) {
    // 标记已读
    return http.post("./notification/updateNotificationRead", data);
  },
  getClassMemberByCode(data) {
    // 根据id查询
    return http.post("./classMember/getClassMemberByCode", data);
  },
  queryClassMemberByTeacherCode(data) {
    // 根据教师code查询所有班级学生
    return http.post("./classMember/queryClassMemberByTeacherCode", data);
  },
  residueTime(data) {
    // 根据教师code查询所有班级学生
    return http.post("./api/experiment/residueTime", data);
  },
  // 学生保存笔记
  saveNote(data) {
    return http.post("./api/experimentMemberNote/saveNote", data);
  },
  // 学生查询笔记
  getNote(data) {
    return http.post("./api/experimentMemberNote/getNote", data);
  },
  // 查询导航栏列表
  getCaseHallNavbarList(pyId) {
    return http.get(`./api/caseHall/getCaseHallNavbarList?pyId=${pyId}`);
  },
  // 编辑and新增导航栏
  updateCaseHallNavbarList(pyId, data) {
    return http.post(`./api/caseHall/updateCaseHallNavbarList${pyId ? `?pyId=${pyId}` : ""}`, data);
  },
  // 删除导航栏
  removeCaseHall(id) {
    return http.delete(`./api/caseHall/removeCaseHall?id=${id}`);
  },
  // 查询树状任务
  getCategoryAndTaskList(chId) {
    return http.get(`./api/TaskCategory/getCategoryAndTaskList?chId=${chId}`);
  },
  // 新增任务
  createTaskCategory(data) {
    return http.post("./api/TaskCategory/createTaskCategory", data);
  },
  removeTaskCategoryOrTask(chId, ids) {
    // ids 父类别
    return http.delete(`./api/TaskCategory/removeTaskCategoryOrTask?chId=${chId}&ids=${ids}`);
  },
  // 修改任务
  batchUpdateTaskOrCategory(data) {
    return http.post("./api/Task/batchUpdateTaskOrCategory", data);
  },
  // 根据分类查询任务
  getTaskByCategoryId(categoryId, chId) {
    return http.get(`./api/TaskCategory/getTaskByCategoryId?chId=${chId}&categoryId=${categoryId}`);
  },
  // 查询资料列表
  listMaterials(taskId) {
    return http.get(`./api/materials/listMaterials?taskId=${taskId}`);
  },
  // 创建更新资料列表
  hanleMaterials(taskId, data) {
    return http.post(`./api/materials/hanleMaterials?taskId=${taskId}`, data);
  },
  // 查询已分配的阶段
  getExperimentById(eId) {
    return http.get(`./api/experiment/getExperimentById?experimentId=${eId}`);
  },
  // 删除部门文件资料库
  batchDeleteInfo(taskId, bizCode) {
    return http.get(`./api/materials/batchDelete?taskId=${taskId}&bizCode=${bizCode}`);
  },
  // 资料库部门文件上传
  MaterialsUploadFile(data) {
    const blob = new FormData();
    blob.append("file", data);
    return http.post("./api/materials/uploadFile", blob);
  }
};
